import React, {useState} from "react";
import '../../../../src/index.css'; 


const FilterButton = ({ text, options, width="253px", onSelect, selectedOption}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        className="border flex items-center h-[40px] w-[200px] md:w-[253px] justify-between text-[#6B7280] border-[#76A140] rounded-md font-itcbook text-[14px] pl-4 focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="text-[#76A140] font-itcmedium">{selectedOption || text}</p>
        <div className="flex items-center justify-center h-full border-l border-[#76A140] px-2 ml-2">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.76756 6.63501H13.4401C13.7131 6.63501 13.854 6.96697 13.6624 7.16306C13.6621 7.1634 13.6617 7.16374 13.6614 7.16409L11.2565 9.56896L9.779 11.0465C9.35176 11.4737 8.65585 11.4737 8.22861 11.0465L4.34361 7.16146C4.14767 6.96551 4.28682 6.63501 4.56006 6.63501H8.76756Z" fill="#76A140" stroke="#76A140"/>
        </svg>
      </div>
      </button>
      {isOpen && (
        <div className="absolute z-10 mt-1 w-[200px] md:w-[253px] bg-white border rounded-md shadow-lg border-green overflow-y-auto scroll-y-container max-h-[255px]">
          {options.map((option, index) => (
            <button
              key={index}
              onClick={() => handleOptionClick(option)}
              className="block w-full px-4 py-2 text-sm text-left rounded-md font-itcbook text-green hover:bg-[#EFEEF7]"
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>

  );
};

export default FilterButton;
